import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  searchUserText: '',
  recordsPerPage: 10,
  pageNumber: 1,
};

export const configureLinksSlice = createSlice({
  name: 'configureLinks',
  initialState: INITIAL_STATE,
  reducers: {
    setSearchUserText: (state, action) => {
      state.searchUserText = action.payload;
    },
    setRecordsPerPage: (state, action) => {
      state.recordsPerPage = action.payload;
    },
    setPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },

    resetconfigureLinks: (state, action) => {
      state.searchUserText = INITIAL_STATE.searchUserText;
      state.recordsPerPage = INITIAL_STATE.recordsPerPage;
      state.pageNumber = INITIAL_STATE.pageNumber;
    },
  },
});

export const {
  setSearchUserText,
  setRecordsPerPage,
  setPageNumber,
  resetconfigureLinks,
} = configureLinksSlice.actions;

export default configureLinksSlice.reducer;
